import { connect } from 'react-redux';
import { setTranslations, setLanguage } from 'redux-i18n';
import Localization from './Localization';

export default connect(({ i18nState: { translations } }) => ({ translations }), {
  setTranslations,
  setLanguage,
})(Localization);
